import { render, staticRenderFns } from "./chatDelete.vue?vue&type=template&id=0f060dcb"
import script from "./chatDelete.vue?vue&type=script&lang=js"
export * from "./chatDelete.vue?vue&type=script&lang=js"
import style0 from "./chatDelete.vue?vue&type=style&index=0&id=0f060dcb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports